import FluxUtils from 'flux/utils';

import SettingsStore from 'sharedreact/stores/SettingsStore';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

import UsageActions from 'workspaces/launcher/actions/UsageActions';
import UsageTrackingTab from 'workspaces/launcher/components/admin/UsageTrackingTab';
import UsageStore from 'workspaces/launcher/stores/UsageStore';
import asFunctional from 'sharedreact/components/asFunctional';

type Props = {
  index: number,
  activeTab: number
};

type State = ConstructorParameters<typeof UsageTrackingTab>[0];

function getStores () {
  return [
    SettingsStore,
    UsageStore
  ];
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  return {
    index: props.index,
    activeTab: props.activeTab,
    language: SettingsStore.getLanguage(),
    didOptIn: UsageStore.getState().didOptIn,
    userName: UsageStore.getState().userName,
    isForTestEnv: UsageStore.getState().testEnv,
    onLogin: UsageActions.optIn,
    onLoad: UsageActions.fetch
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(UsageTrackingTab),
  getStores,
  calculateState,
  { withProps: true }
);
